import { SortOptions } from '@/shared/types/common';

export const intakesSortOptions: SortOptions[] = [
  {
    id: 'default',
    title: 'Sort by: Default',
    options: [
      { label: 'Date Created (Newest)', value: 'createdAt:desc' },
      { label: 'Date Created (Oldest)', value: 'createdAt:asc' },
      { label: 'Start Date (Newest)', value: 'startDate:desc' },
      { label: 'Start Date (Oldest)', value: 'startDate:asc' },
      { label: 'End Date (Newest)', value: 'endDate:desc' },
      { label: 'End Date (Oldest)', value: 'endDate:asc' },
      { label: 'Title A-Z', value: 'title:asc' },
      { label: 'Title Z-A', value: 'title:desc' },
      { label: 'Students (High-Low)', value: 'studentCount:desc' },
      { label: 'Students (Low-High)', value: 'studentCount:asc' },
    ],
  },
];

